export default __webpack_public_path__ + "static/media/gary.05bda644.png";